'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var Vue = _interopDefault(require('vue'));
var ActionSheetOptions = _interopDefault(require('./index'));

var instance = {
  create: function create() {
    if (!instance.actionSheet) {
      instance.actionSheet = new Vue(_objectSpread({}, ActionSheetOptions, {
        el: document.createElement('div')
      }));
      instance.actionSheet.$on('hide', this.hide);
      document.body.appendChild(instance.actionSheet.$el);
    }
  },
  show: function show(options) {
    instance.create();
    instance.actionSheet.show = true;
    instance.actionSheet.options = options;
  },
  hide: function hide() {
    instance.actionSheet && (instance.actionSheet.show = false);
  }
};

exports.default = instance;
